<div class="page">
    <lta-menu class="nav"></lta-menu>
    <main class="main">
        <router-outlet></router-outlet>
    </main>
</div>

<lta-flash-messages></lta-flash-messages>
